<template>
    <router-view />
</template>

<script>
    export default {
        name: 'TriggeredAction',
    }
</script>

<style scoped>

</style>